import React, { Component } from "react";
import "./mapPage.css";
import "react-input-range/lib/css/index.css";

import MapContainer from "../components/MapContainer";
import { PortionsContext } from "../context/PortionsContext";
import MapHeader from '../components/headers/Map';
import Filters from "../components/Filters";
import Spinner from "../components/Spinner";
import Map from "../components/map";
import { isDesktop } from "react-device-detect";
import MapInfo from "../components/MapInfo";
import PortionSelector from "../components/PortionSelector";
import InputSearch from "../components/InputSearch";

class MapPage extends Component {
  viewport = {
    height: "calc(100vh - var(--header-height) - var(--detailHeaders-height))",
  }

  constructor(props) {
    super(props);

    this.state = {
      showParcelInfo: false,
      parcelInfo: null,
    }
  }

  render() {
    if (this.context.isLoading) {
      return (
        <div className="spinner-container" style={{
          minHeight: this.viewport.height,
          height: `calc(100vh + var(--detailHeaders-height) - var(--header-height) - var(--detailHeaders-height)`,
        }}><Spinner /></div>
      )
    }

    const setCurrentLoteamiento = (parcel) => {
      if (isDesktop) {
        this.setState({
          showParcelInfo: true,
          parcelInfo: parcel,
        });
      } else {
        goToCurrentLoteamiento(parcel);
      }
    }

    const goToCurrentLoteamiento = (parcel) => {
      this.context.setCurrentLoteamiento(parcel);
      hideParcelInfo();
    }

    const hideParcelInfo = () => {
      this.setState({
        showParcelInfo: false,
        parcelInfo: null,
      });
    }

    return (
      <>
        <MapHeader goToProfile={() => { }} />
        <Filters />
        <MapInfo showInfo={true} context={this.context} />
        <InputSearch className="map-input desktop-noDisplay" />
        <div style={{ position: "relative" }}>
          <MapContainer action="show" largeMode={true} showInfo={true} navigation={false}>
            <Map
              ref={this.context.map}
              action="show"
              showParcelInfo={this.state.showParcelInfo}
              hideParcelInfo={hideParcelInfo}
              parcelInfo={this.state.parcelInfo}
              unsetLoteamiento={this.context.unsetLoteamiento}
              setCurrentLoteamiento={setCurrentLoteamiento}
              goToCurrentLoteamiento={goToCurrentLoteamiento}
              name={this.context.selectedLoteamiento?.properties.name}
              phone={this.context.selectedLoteamiento?.properties.whatsapp_number}
              markers={this.context.portions || []}
              currentLoteamientoId={this.context.selectedLoteamiento?.id}
              parcels={this.context.parcels}
              left="var(--filters-width)"
              viewport={{
                ...this.context.viewport,
                height: "calc(100vh - var(--header-height) - var(--detailHeaders-height))"
              }}
              blocksCentralPoints={this.context.blocksCentralPoints}
              history={this.history}
              optionsMode="large"
              hasInfo={true}
            />
          </MapContainer>
        </div>
      </>
    )
  }
}

MapPage.contextType = PortionsContext;

export default MapPage;
